import type { AlertBannerCardProps } from '../../../types/alerts.d';
import './AlertBannerCard.scss';
import React, { forwardRef } from 'react';
// import { AlertPoster } from './AlertPoster';
import { AlertBannerCardAccordion } from './AlertBannerCardAccordion';
import { AlertBannerCardLink } from './AlertBannerCardLink';


export const AlertBannerCard = forwardRef<HTMLDivElement, AlertBannerCardProps>((
	{
		alertListLink,
		content,
		date,
		empty,
		id,
		image,
		isHighlighted,
		location,
		showSpinner,
		title,
		variant,
		alertType,
	}, refFromParent,
) => {

	if (variant === 'link') return (
		<AlertBannerCardLink
			{...{alertListLink, date, id, image, location, title, alertType}}
		/>
	);

	return (
		<>
			{/* Useful when working on dimensions, etc. */}
			{/* <AlertPoster
				appearance={content.appearance}
				descriptionHtml={content.description}
				expiresAt={date.expireStringOrUndef as string}
				imgSrc={image?.url}
				published={date.published}
				recommendationHtml={content.recommendation}
				title={title}
			/> */}
			<AlertBannerCardAccordion
				{...{
					content,
					date,
					empty,
					image,
					isHighlighted,
					location,
					ref: refFromParent,
					showSpinner,
					title,
					alertType,
				}}
			/>
		</>
	);
});
